import { getUrlForMedia, InternalArpMedia } from '@arpeggi/shared'
import axios from '../../lib/axios'

const getFunctionName = () => getFunctionName.caller.name
export const fetchArpWaveform = async (arpMedia: InternalArpMedia): Promise<ArrayBuffer> => {
  // This converts from possible Arweave and IPFS addresses, and prioritizes cached samples
  // (e.g. ar://12345) to valid URLs (https://arweave.net/12345).
  const dataUrl = getUrlForMedia(arpMedia)
  const res = await axios.get<ArrayBuffer>(dataUrl, { responseType: 'arraybuffer' })
  if (!res.data)
    throw new Error(`[${getFunctionName()}] error fetching sample waveform from ${dataUrl}`)
  return res.data
}
